<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header blue-gradient">Peticiones (darse de alta)</div>
                    <div class="card-body table-responsive">
                        <table class="table table-stripped text-center" id="entities-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Nombre completo</th>
                                    <th>Documento</th>
                                    <th>Motivo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="petition in petitions" :key="petition.id">
                                    <td>{{petition.id}}</td>
                                    <td>{{petition.fullname}}</td>
                                    <td>{{petition.document}}</td>
                                    <td>{{petition.description}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'cities',
    created: function(){
        this.fetchPetitions();
    },
    data(){
        return {
            baseUrl: process.env.VUE_APP_API,
            petitions: []
        }
    },
    methods: {
        fetchPetitions(){
            const loader = this.$loading.show();
            const requestUrl = `${this.baseUrl}/admin/petitions`;
            this.$http.get(requestUrl,
            {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(data => {
                console.log(data);
                this.petitions = data.body.data;
                loader.hide();
            })
        },
    }

}
</script>
<style lang="sass" scoped>
    @import '../../assets/scss/colors';
</style>


